import { httpClient } from '@/api/http';

export interface DashboardOverview {
  totalUsers: number;
  totalVendors: number;
  totalCoupons: number;
  totalRedeemedCoupons: number;
  totalRevenue: number;
}

export interface OverviewItem {
  hour?: string;
  week?: string;
  month?: string;
  revenue: number;
  growthPercentage: number;
}

export interface VendorPerformanceItem {
  merchantId: number;
  merchantName: string;
  couponSalesCount: number;
  revenueGenerated: number;
}

export interface DashboardResponse {
  overview: DashboardOverview;
  hourlyOverview?: OverviewItem[];
  weeklyOverview?: OverviewItem[];
  monthlyOverview?: OverviewItem[];
  topVendors?: VendorPerformanceItem[];
  vendorPerformance?: VendorPerformanceItem[];
}

export interface GetDashboardParams {
  fromDate?: string; // yyyy-mm-dd
  toDate?: string;   // yyyy-mm-dd
}

export async function getDashboard(params?: GetDashboardParams): Promise<DashboardResponse> {
  const { data } = await httpClient.get<DashboardResponse>('/admin/dashboard', { params });
  return data;
}
